import cx from 'classnames';
import PropTypes from 'prop-types';

import { CUSTOM_BUTTON_VARIANT, CustomButton } from 'src/components/CustomButton';
import { CustomTooltip } from 'src/components/CustomTooltip';

import { useStyles } from './useStyles';

export const SubmitButton = ({ className, onClick, disabled, loading, title, draft, tooltip }) => {
  const styles = useStyles();

  return (
    <CustomTooltip title={tooltip || ''}>
      <div className={cx(styles.root, className)}>
        <CustomButton
          className={styles.submitButton}
          onClick={onClick}
          loading={loading}
          disabled={disabled || loading}
          variant={draft ? CUSTOM_BUTTON_VARIANT.outlined : CUSTOM_BUTTON_VARIANT.contained}
          data-testid="nextButton"
        >
          {title || 'Next'}
        </CustomButton>
      </div>
    </CustomTooltip>
  );
};

SubmitButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  title: PropTypes.string,
  draft: PropTypes.bool,
  tooltip: PropTypes.string,
};

SubmitButton.defaultProps = {
  className: null,
  disabled: false,
  loading: false,
  title: null,
  draft: false,
  tooltip: null,
};
